const placePictureInPicture = (element) => {

    const elem = document.getElementById(element);
    console.log("placePictureInPicture")
    elem.requestPictureInPicture()

}

export default placePictureInPicture